import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getPlaces, getPlacesLoading } from './redux/selectors';
import Map from '../../map/Map';
import MapPin from '../../icons/mapPin.svg';
import { Modal } from 'react-bootstrap';
import './styles.scss';
import { noop } from '../../common/propTypes';

function ViewAllPlaces({ places, open, handleClose }) {
    const dataPoints = places.map((place) => ({
        id: place.id,
        icon: MapPin,
        position: {
            lat: place.location ? place.location.lat : 0,
            lng: place.location ? place.location.long : 0,
        },
        tags: [place.name],
    }));
    return (
        <Modal
            show={open}
            size={'xl'}
            onHide={() => handleClose(false)}
            className={'assign-partner-modal'}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            centered={true}
            animation={true}
        >
            <div className="modal-body add-places-modal">
                <div className="row">
                    <div className="col">
                        <Map
                            id="all-places-map"
                            center={{
                                lat: dataPoints[0]
                                    ? parseFloat(dataPoints[0].position.lat)
                                    : 0,
                                lng: dataPoints[0]
                                    ? parseFloat(dataPoints[0].position.lng)
                                    : 0,
                            }}
                            markerClickable={false}
                            dataPoints={dataPoints}
                            zoom={13.0}
                            options={{
                                scrollwheel: false,
                                disableDefaultUI: true,
                                zoomControl: true,
                            }}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
}

ViewAllPlaces.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    isLoading: PropTypes.bool,
    places: PropTypes.array,
};

ViewAllPlaces.defaultProps = {
    open: false,
    handleClose: noop,
    isLoading: false,
    places: [],
};

const mapStateToProps = (state) => {
    return {
        places: getPlaces(state),
        isLoading: getPlacesLoading(state),
    };
};

export default connect(mapStateToProps, null)(ViewAllPlaces);
